<template>
  <div>
    <el-row type="flex" justify="end" class="flex-wrap-wrap">
      <el-col :xs="24" :sm="24" :md="12" :lg="14" :xl="14">
        <el-form :inline="true" label-width="82px">
          <el-form-item label="日期范围：">
            <el-date-picker
              v-model="range"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width:260px;margin-left:5px;"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submit">查询</el-button>
            <el-button>重置</el-button>
            <el-button
              type="text"
              style="margin-left:1rem;display:inline-block;"
              @click="exportExcel"
            >
              导出Excel
            </el-button>
          </el-form-item>
        </el-form>
      </el-col>

      <el-col
        :xs="24"
        :sm="24"
        :md="12"
        :lg="10"
        :xl="10"
        class="text-right report-search-flex"
      >
        <div v-if="type === 'data'" class="report-search-item">
          <span style="margin-right: 4px;">显示0值</span>
          <el-switch
            v-model="showZero"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="true"
            :inactive-value="false"
            @change="showZeroChange"
          >
          </el-switch>
        </div>

        <el-radio-group
          style="margin-right: 10px"
          :value="groupType"
          @input="groupTypeChange"
        >
          <el-radio-button label="insect">
            昆虫分类
          </el-radio-button>
          <el-radio-button label="device">
            设备分类
          </el-radio-button>
        </el-radio-group>

        <el-radio-group
          style="margin-right: 10px"
          :value="type"
          @input="showTypeChange"
        >
          <el-radio-button label="preview">
            图表
          </el-radio-button>
          <el-radio-button label="data">
            数据视图
          </el-radio-button>
        </el-radio-group>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { formatDate, subtract } from '@/utlis/date'
export default {
  props: { type: String, groupType: String },
  data() {
    return {
      range: [
        subtract(undefined, 30, 'days', 'YYYY-MM-DD'),
        formatDate(undefined, 'YYYY-MM-DD')
      ],
      device: null,
      showZero: true
    }
  },
  mounted() {
    this.$emit('zero-change', this.showZero)
  },
  methods: {
    submit() {
      let [beginDate, endDate] = this.range
      this.$emit('go-search', { beginDate, endDate, deviceIds: this.device })
    },
    reset() {
      this.range = []
      this.device = null
    },
    exportExcel() {
      let [begin, end] = this.range
      this.$emit('export-excel', `${begin}_${end}`)
    },
    showTypeChange(type) {
      this.$emit('show-type-change', type)
    },
    groupTypeChange(type) {
      this.$emit('group-type-change', type)
    },
    showZeroChange(v) {
      this.$emit('zero-change', v)
    }
  }
}
</script>

<style lang="css" scoped>
.report-search-flex {
  display: flex;
  justify-content: center;
  justify-content: flex-end;
}
.report-search-item {
  height: 32px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-right: 20px;
  font-size: 14px;
}
</style>
